import { isBrowser } from "../is-browser.qwik.mjs";
import { isEditing } from "../is-editing.qwik.mjs";
import { getUserAttributes } from "../track/helpers.qwik.mjs";
const getFunctionArguments = ({ builder, context, event, state }) => {
  return Object.entries({
    state,
    Builder: builder,
    // legacy
    builder,
    context,
    event
  });
};
const getBuilderGlobals = () => ({
  isEditing: isEditing(),
  isBrowser: isBrowser(),
  isServer: !isBrowser(),
  getUserAttributes: () => getUserAttributes()
});
const parseCode = (code, { isExpression = true }) => {
  const useReturn = (
    // we disable this for cases where we definitely don't want a return
    isExpression && !(code.includes(";") || code.includes(" return ") || code.trim().startsWith("return "))
  );
  const useCode = useReturn ? `return (${code});` : code;
  return useCode;
};
function flattenState({ rootState, localState, rootSetState }) {
  return new Proxy(rootState, {
    get: (target, prop) => {
      if (localState && prop in localState)
        return localState[prop];
      const val = target[prop];
      if (typeof val === "object" && val !== null)
        return flattenState({
          rootState: val,
          localState: void 0,
          rootSetState: rootSetState ? (subState) => {
            target[prop] = subState;
            rootSetState(target);
          } : void 0
        });
      return val;
    },
    set: (target, prop, value) => {
      if (localState && prop in localState)
        throw new Error("Writing to local state is not allowed as it is read-only.");
      target[prop] = value;
      rootSetState == null ? void 0 : rootSetState(target);
      return true;
    }
  });
}
export {
  flattenState,
  getBuilderGlobals,
  getFunctionArguments,
  parseCode
};
